import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as lessonSelectors from '../selectors';
import * as lessonActions from '../actions';
import { STATUS } from '../constants';

export const useLesson = (lessonId, isDemo = false) => {
  const dispatch = useDispatch();

  const lesson = useSelector((state) =>
    lessonSelectors.getLessonByLessonId(state, lessonId)
  );

  const lessonLoadingStatus = useSelector((state) =>
    lessonSelectors.getLessonStatusByLessonId(state, lessonId)
  );

  useEffect(() => {
    if (lessonLoadingStatus === STATUS.UNINITIALIZED) {
      dispatch(lessonActions.loadLessonByLessonId.signal(lessonId, isDemo));
    }
  }, [dispatch, lessonId, lessonLoadingStatus, isDemo]);

  const noLesson = !lesson?.get('id');

  return {
    data: lesson,
    isLoading:
      [STATUS.LOADING, STATUS.SUBMITTING].includes(lessonLoadingStatus) ||
      noLesson,
    error: lessonLoadingStatus === STATUS.ERROR ? 'Error loading lesson' : null,
  };
};
